<template>
  <div>
    <b-row class="mb-5"
      ><b-col
        ><div class="tsny_header text-center">{{ name }}</div></b-col
      ></b-row
    >
    <b-row class="mb-3">
      <b-col
        ><b-table
          fixed
          class="tsny_text-mid text-center"
          borderless
          thead-tr-class="tsny_table-head"
          tbody-tr-class="tsny_table-body tsny_table-body-collapse"
          details-td-class="tsny_table-details"
          :fields="fields"
          :items="formattedItems"
        >
          <template v-slot:table-colgroup="scope">
            <col
              v-for="field in scope.fields"
              :key="field.key"
              :style="columnCSS(field)"
            />
          </template>
          <template v-slot:cell(category)="row">
            <div
              class="tsny_table-details-container"
              @click="row.toggleDetails"
            >
              <span
                >{{ row.item.category }}
                <i
                  class="fas float-right pt-1"
                  :class="row.detailsShowing ? 'fa-angle-up' : 'fa-angle-down'"
              /></span>
            </div>
          </template>
          <template v-slot:cell(graph)="data">
            <response-graph
              :correct="data.item.correct"
              :incorrect="data.item.incorrect"
              :omitted="data.item.omitted"
              :height="20"
            />
          </template>
          <template v-slot:row-details="row">
            <b-table
              fixed
              class="tsny_text text-center mb-0"
              borderless
              thead-tr-class="display_none"
              tbody-tr-class="tsny_table-body tsny_table-body-collapse-child"
              :fields="fields"
              :items="row.item.subcategories"
            >
              <template v-slot:table-colgroup="scope">
                <col
                  v-for="field in scope.fields"
                  :key="field.key"
                  :style="columnCSS(field)"
                />
              </template>
              <template v-slot:cell(category)="data">
                {{ data.item.category }} ({{ data.item.abbreviation }})
              </template>
              <template v-slot:cell(graph)="data">
                <response-graph
                  :correct="data.item.correct"
                  :incorrect="data.item.incorrect"
                  :omitted="data.item.omitted"
                  :height="10"
                />
              </template>
            </b-table>
          </template> </b-table
      ></b-col>
    </b-row>
    <b-row class="mb-5">
      <b-col>
        <answer-key :subsection-name="name" :answer-key="answerKey" />
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { _ } from "vue-underscore";
import ResponseGraph from "./ResponseGraph";
import AnswerKey from "./AnswerKey";

export default {
  name: "Breakdown",
  components: { AnswerKey, ResponseGraph },
  props: {
    name: {
      type: String,
      default: null
    },
    breakdown: {
      type: Object,
      default: null
    }
  },
  computed: {
    formattedItems() {
      let section = this.breakdown;

      return _.keys(section.subscoreBreakdown).map(key => ({
        category: key,
        ...section.subscoreBreakdown[key],
        subcategories: _.keys(
          section.subscoreBreakdown[key].subcategoryBreakdown
        ).map(subKey => ({
          category: subKey,
          ...section.subscoreBreakdown[key].subcategoryBreakdown[subKey]
        }))
      }));
    },
    answerKey() {
      return this.breakdown.answerKey;
    }
  },
  data: () => ({
    fields: [
      { key: "category", label: "Category/Topic" },
      { key: "graph", label: "Response Graph" },
      { key: "correct" },
      { key: "incorrect" },
      { key: "omitted" },
      { key: "total" }
    ]
  }),
  methods: {
    columnCSS(field) {
      return {
        width: ["category", "graph"].includes(field.key)
          ? "auto"
          : field.key === "incorrect"
          ? "90px"
          : "75px"
      };
    }
  }
};
</script>

<style scoped></style>
